import { makeRequest, CommonRequestOptions } from '../../makeRequest';
import { UserStatus, EditUserPrivilege } from '~/monolith-api/users/manage';

export type SortDirectionOptions = 'ASC' | 'DESC';

export type SortColumn =
   | 'id'
   | 'name'
   | 'email'
   | 'privilege'
   | 'status'
   | 'date_created'
   | 'last_login'
   | 'job_title'
   | 'department'
   | 'shift'
   | 'location'
   | 'plant'
   | 'address_line_1'
   | 'address_line_2'
   | 'city'
   | 'country_region'
   | 'state_province'
   | 'postal_code'
   | 'zone_code'
   | 'employment_type'
   | 'job_type'
   | 'date_started'
   | 'date_terminated'
   | 'employee_id'
   | 'preferred_name'
   | 'company'
   | 'division'
   | 'manager_name'
   | 'manager_employee_id'
   | 'group'
   | 'group_code'
   | 'job_code'
   | 'employment_status'
   | 'preferred_language';

export type GetUsersManageRequestFilterOptions = {
   userids?: number[];
   privilege?: EditUserPrivilege[];
   status?: UserStatus[];
   date_created?: {
      from: number;
      to: number;
   };
   last_login?: {
      from: number;
      to: number;
   };
};

export type GetUsersManageRequestSortOptions = {
   field?: SortColumn;
   direction: SortDirectionOptions;
};

export type UserManage = {
   id: number;
   name: string;
   email: string;
   privilege: EditUserPrivilege;
   status: UserStatus;
   date_created: number;
   last_login: number;
   job_title?: string;
   department?: string;
   shift?: string;
   location?: string;
   plant?: string;
   address_line_1?: string;
   address_line_2?: string;
   city?: string;
   country_region?: string;
   state_province?: string;
   postal_code?: string;
   zone_code?: string;
   employment_type?: string;
   job_type?: string;
   date_started?: number;
   date_terminated?: number;
   employee_id?: string;
   preferred_name?: string;
   company?: string;
   division?: string;
   manager_name?: string;
   manager_employee_id?: string;
   group?: string;
   group_code?: string;
   job_code?: string;
   employment_status?: string;
   preferred_language?: string;
};

export type GetUsersManageRequestOptions = CommonRequestOptions & {
   limit: number;
   offset: number;
   filters?: GetUsersManageRequestFilterOptions;
   searchTerm?: string;
   sort?: GetUsersManageRequestSortOptions;
};

export type GetUsersManageResult = {
   totalEntries: number;
   users: UserManage[];
};

export async function getUsersManage({
   limit,
   offset,
   filters,
   searchTerm,
   sort,
   ...common
}: GetUsersManageRequestOptions): Promise<GetUsersManageResult> {
   return makeRequest('post', 'users/manage', {
      ...common,
      body: {
         limit: limit,
         offset: offset,
         filters: filters,
         search_term: searchTerm,
         sort: sort,
      },
   });
}
